module.exports = __webpack_public_path__ + "assets/img/tracked-box1-icon4.a8ad358a.svg";